import {
  FETCH_FAVORITE,
  FETCH_FAVORITE_SUCCEED,
  FETCH_FAVORITE_FAILED,
  CREATE_FAVORITE,
  CREATE_FAVORITE_SUCCEED,
  CREATE_FAVORITE_FAILED,
  FETCH_FAVORITE_DETAIL,
  FETCH_FAVORITE_DETAIL_SUCCEED,
  FETCH_FAVORITE_DETAIL_FAILED,
  REMOVE_FAVORITE,
  REMOVE_FAVORITE_SUCCEED,
  REMOVE_FAVORITE_FAILED,
} from './action_types';

export default {
  fetchFavorite: (params, callback) => ({
    type: FETCH_FAVORITE,
    params,
    callback,
  }),
  fetchFavoriteSucceed: (data) => ({
    type: FETCH_FAVORITE_SUCCEED,
    data,
  }),
  fetchFavoriteFailed: (err) => ({
    type: FETCH_FAVORITE_FAILED,
    err,
  }),

  createFavorite: (data) => ({
    type: CREATE_FAVORITE,
    data,
  }),
  createFavoriteSucceed: (data) => ({
    type: CREATE_FAVORITE_SUCCEED,
    data,
  }),
  createFavoriteFailed: (err) => ({
    type: CREATE_FAVORITE_FAILED,
    err,
  }),

  fetchFavoriteDetail: (params, callback) => ({
    type: FETCH_FAVORITE_DETAIL,
    params,
    callback,
  }),
  fetchFavoriteDetailSucceed: (data) => ({
    type: FETCH_FAVORITE_DETAIL_SUCCEED,
    data,
  }),
  fetchFavoriteDetailFailed: (err) => ({
    type: FETCH_FAVORITE_DETAIL_FAILED,
    err,
  }),

  removeFavorite: (params) => ({
    type: REMOVE_FAVORITE,
    params,
  }),
  removeFavoriteSucceed: (data) => ({
    type: REMOVE_FAVORITE_SUCCEED,
    data,
  }),
  removeFavoriteFailed: (err) => ({
    type: REMOVE_FAVORITE_FAILED,
    err,
  }),
};
